import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppConfigService } from '../app-config.service';
import { FetchInterceptorService } from '../fetch-edc.interceptor';

/**
 * Attaches the Bearer token (or API key fallback) to outgoing HttpClient requests
 * that target the management API or catalog URL.
 *
 * This mirrors the auth logic in FetchInterceptorService, which only covers
 * window.fetch calls made by the @think-it-labs/edc-connector-client library.
 * Services that use Angular HttpClient directly (e.g. AssetService v5beta) rely on this interceptor.
 */
@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  constructor(
    private readonly oauthService: OAuthService,
    private readonly appConfig: AppConfigService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const config = this.appConfig.getConfig();
    if (!config) {
      return next.handle(req);
    }

    const isBackend = FetchInterceptorService.isBackendUrl(req.url, config);

    if (!isBackend) {
      return next.handle(req);
    }

    const accessToken = this.oauthService.getAccessToken();

    let authReq: HttpRequest<unknown>;
    if (accessToken) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` },
      });
    } else if (config.edcApiKey) {
      authReq = req.clone({
        setHeaders: { 'X-Api-Key': config.edcApiKey },
      });
    } else {
      // No auth configured — pass through as-is
      return next.handle(req);
    }

    return next.handle(authReq);
  }
}
